import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';
import {
  ISubFolderFieldsFragment,
  PermissionKey,
} from '../../../../utils/apollo/graphqlSchema';
import ActionsMenu from '../../../../components/ActionsMenu';
import { SUB_FOLDERS_MAX_DEPTH } from '../../../../config/constants';
import { SingleSelectOption } from '../../../../components/Dropdown/SingleSelect';
import usePermission from '../../../../utils/hooks/permissionHooks';
interface IProps {
  path: ISubFolderFieldsFragment[];
  onCreateFolder: () => void;
}

const StyledActionsMenu = styled(ActionsMenu)`
  flex: 0 0 auto;
  display: inline-flex;
`;

const PublishedDashboardActions = ({ path, onCreateFolder }: IProps) => {
  const { checkIsPermitted } = usePermission();

  const isPermittedToCreateFolder = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.DashboardFolderCreate],
  });

  const handleCreateFolder = (event: SyntheticEvent) => {
    event.stopPropagation();
    onCreateFolder();
  };

  return (
    <StyledActionsMenu
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <SingleSelectOption
        iconName="folder-plus"
        label={'Add New Folder'}
        onClick={handleCreateFolder}
        disabled={
          path.length >= SUB_FOLDERS_MAX_DEPTH || !isPermittedToCreateFolder
        }
      />
    </StyledActionsMenu>
  );
};

export default PublishedDashboardActions;
